/* @flow */

import Immutable from 'immutable';
import { bindSelectors, memoizeSelectors } from './selectors';
import config from '../config';

const Selectors = {
  getQuery(state: Immutable.Map): string {
    return state.get('query');
  },
  isCollapsed(state: Immutable.Map): boolean {
    return state.get('isCollapsed');
  },
  getSearchResults(state: Immutable.Map): Immutable.List {
    return state.getIn(['searchResults', 'all'], Immutable.List([]));
  },
  getSearchResultsPage(state: Immutable.Map): Immutable.List {
    return state.getIn(['searchResults', 'page']);
  },
  hasPrevSearchPage(state: Immutable.Map): boolean {
    return (state.getIn(['searchResults', 'page', 'number']) > 1);
  },
  hasNextSearchPage(state: Immutable.Map): boolean {
    var pageNumber = state.getIn(['searchResults', 'page', 'number']);
    var numResults = state.getIn(['searchResults', 'all']).size;
    return ((pageNumber * config.MAX_SEARCH_RESULTS) < numResults);
  },
  getNumSearchResults(state: Immutable.Map): number {
    return state.getIn(['searchResults', 'all']).size;
  },
  isLoading(state: Immutable.Map): boolean {
    return state.get('isLoading');
  },
  getActiveId(state: Immutable.Map): number {
    return state.get('activeId');
  },
};

const UnboundSidePanelSelectors = memoizeSelectors(Selectors);
const SidePanelSelectors = bindSelectors('sidepanel', UnboundSidePanelSelectors);

export {
  SidePanelSelectors,
  UnboundSidePanelSelectors
};
